/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_TitleInputs */

const id_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik`)
};

const ms_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik`)
};

const da_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik`)
};

const de_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken`)
};

const en_us2_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

const es_es2_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas`)
};

const es_mx2_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas`)
};

const fil_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadistika`)
};

const fr_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques`)
};

const it_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche`)
};

const hu_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statisztikák`)
};

const nl_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistieken`)
};

const no_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistikk`)
};

const pl_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki`)
};

const pt_br2_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

const pt_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas`)
};

const ro_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistici`)
};

const fi_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilastot`)
};

const sv_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik`)
};

const vi_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê`)
};

const tr_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstatistikler`)
};

const cs_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiky`)
};

const bg_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика`)
};

const ru_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика`)
};

const uk_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика`)
};

const ar_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإحصائيات`)
};

const hi_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आँकड़े`)
};

const th_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติ`)
};

const ja_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統計`)
};

const zh_cn2_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

const zh_hant1_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

const ko_components_stats_title = /** @type {(inputs: Components_Stats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stats`)
};

/**
* | output |
* | --- |
* | "Stats" |
*
* @param {Components_Stats_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_title = /** @type {((inputs?: Components_Stats_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_title(inputs)
	if (locale === "ms") return ms_components_stats_title(inputs)
	if (locale === "da") return da_components_stats_title(inputs)
	if (locale === "de") return de_components_stats_title(inputs)
	if (locale === "en-US") return en_us2_components_stats_title(inputs)
	if (locale === "es-ES") return es_es2_components_stats_title(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_title(inputs)
	if (locale === "fil") return fil_components_stats_title(inputs)
	if (locale === "fr") return fr_components_stats_title(inputs)
	if (locale === "it") return it_components_stats_title(inputs)
	if (locale === "hu") return hu_components_stats_title(inputs)
	if (locale === "nl") return nl_components_stats_title(inputs)
	if (locale === "no") return no_components_stats_title(inputs)
	if (locale === "pl") return pl_components_stats_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_title(inputs)
	if (locale === "pt") return pt_components_stats_title(inputs)
	if (locale === "ro") return ro_components_stats_title(inputs)
	if (locale === "fi") return fi_components_stats_title(inputs)
	if (locale === "sv") return sv_components_stats_title(inputs)
	if (locale === "vi") return vi_components_stats_title(inputs)
	if (locale === "tr") return tr_components_stats_title(inputs)
	if (locale === "cs") return cs_components_stats_title(inputs)
	if (locale === "bg") return bg_components_stats_title(inputs)
	if (locale === "ru") return ru_components_stats_title(inputs)
	if (locale === "uk") return uk_components_stats_title(inputs)
	if (locale === "ar") return ar_components_stats_title(inputs)
	if (locale === "hi") return hi_components_stats_title(inputs)
	if (locale === "th") return th_components_stats_title(inputs)
	if (locale === "ja") return ja_components_stats_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_title(inputs)
	return ko_components_stats_title(inputs)
});
export { components_stats_title as "components.stats.title" }